import styled from '@emotion/styled';
import { useAtomValue } from 'jotai';
import Link from 'next/link';
import { tempFindUserAtom } from '../..';
import { useSignPageControl } from '../../use-sign-page-control';
import Button from '@/components/comm/Button';
import { breakpointSmall } from '@/constants/breakpoints';
import { colors } from '@/constants/colors';

const AlreadyUserDiv = styled.div`
padding: 40px 32px;
text-align: center;

@media (max-width: ${breakpointSmall}) {
  padding: 40px 20px;
}
`;

const ContentFirstDiv = styled.div`
color: ${colors.black};
font-size: 18px;
font-weight: 700;
line-height: 26px;
`;

const ContentSecondDiv = styled.div`
margin-top: 17px;
color: ${colors.indigo};
font-size: 14px;
font-weight: 400;
line-height: 24px;
`;

const BottomDiv = styled.div`
display: flex;
margin-top: 340px;
gap: 12px;

@media (max-width: ${breakpointSmall}) {
  flex-direction: column;
  margin-top: 200px;
}
`;

const BottomBtn = styled(Button)`
height: 54px;
flex-grow: 1;
`;

const AlreadyUser = () => {
  const { email } = useAtomValue(tempFindUserAtom);

  const { push } = useSignPageControl();

  return (
    <AlreadyUserDiv>
      <ContentFirstDiv>이미 통합회원이시군요</ContentFirstDiv>
      <ContentSecondDiv>회원 이메일({email})로<br />로그인을 하시거나 비밀번호 재설정을 진행해주세요</ContentSecondDiv>
      <BottomDiv>
        <Link href="/sign?page=resetpassword">
          <BottomBtn styleType="normal">비밀번호 찾기</BottomBtn>
        </Link>
        <BottomBtn onClick={() => push('in')}>로그인하기</BottomBtn>
      </BottomDiv>
    </AlreadyUserDiv>
  );
};

export default AlreadyUser;
